module.exports = __webpack_public_path__ + "static/media/pt_credit_card.c3a41814.svg";